import { atomWithStorage } from 'jotai/vanilla/utils';

/**
 * User settings interface
 */
export interface Settings {
  soundEnabled: boolean;
  musicEnabled: boolean;
  difficulty: 'easy' | 'medium' | 'hard';
  theme: 'light' | 'dark';
}

/**
 * User settings atom with localStorage persistence
 * Key: spillesammen:settings
 */
export const settingsAtom = atomWithStorage<Settings>('spillesammen:settings', {
  soundEnabled: true,
  musicEnabled: true,
  difficulty: 'medium',
  theme: 'dark',
});
